<template>
  <router-view/>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default {
    name: 'App',
    setup() {
        const i18n = useI18n();
        const router = useRouter();

        router.beforeEach((to, from, next) => {
            if (to.meta && to.meta.title) {
                let title = i18n.t(to.meta.title);
                if (to.params && to.params.id) {
                    title += ': #' + to.params.id;
                }
                document.title = title;
            }
            next();
        });
    }
}

</script>
